import React, {useState, useEffect} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Config from "../../core/config";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import ConfirmButton from "../common/ConfirmButton";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import Loading from "../../core/Loading";
import {usePermission} from "../../core/PermissionContext";
import {UserPermission} from "../../utils/utils";

const apiUrl = Config.apiUrl;

const ProductAutomotiveServiceManager = () => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const [loading, setLoading] = useRecoilState(loadingAtom);
    const [formData, setFormData] = useState({
        id: 0,
        name: '',
        type: '',
        value: 0.0
    });

    useEffect(() => {
        if (id) {
            makeQuery();
        }
    }, [id]);

    async function makeQuery() {
        try {
            setLoading(true);
            const url = `${apiUrl}/api/products/id=${id}`;
            const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
            setFormData(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    function clearEntity() {
        setFormData({
            id: 0,
            name: '',
            type: '',
            value: 0.0
        });
    }

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    function validateInputs() {
        if (!formData.name || formData.name === '') {
            alert('Preencha o campo Nome.');
            return false;
        }

        if (!formData.type || formData.type === '') {
            alert('Selecione um tipo.');
            return false;
        }

        return true;
    }

    const onConfirm = async () => {
        try {
            if (validateInputs()) {
                await saveEntity();
                navigate('/app/productautomotiveservicelist');
            }
        } catch (error) {
            console.error('Error saving:', error);
            alert('Erro ao salvar: ' + (error.message || error));
        } finally {
            setLoading(false);
        }
    };

    async function saveEntity() {
        const userUUID = Cookies.get('userUUID');
        const url = apiUrl + '/api/products';
        
        try {
            setLoading(true);
            const response = await makeRequest(url, id ? 'PUT' : 'POST', {
                'Content-Type': 'application/json',
                'Useruuid': userUUID,
            }, JSON.stringify(formData));
            setLoading(false);
            return response;
        } catch (error) {
            setLoading(false);
            throw error;
        }
    }

    if (loadingPermissions) {
        return <Loading/>;
    }

    if (!hasUserPermission(UserPermission.CREATE_AUTOMOTIVE_SERVICE_PRODUCTS) && !hasUserPermission(UserPermission.EDIT_AUTOMOTIVE_SERVICE_PRODUCTS)) {
        return <div>Acesso negado</div>;
    }

    return (
        <div style={{width: '1000px'}}>
            <div className="header-label">{formData.id > 0 ? 'Editar' : 'Cadastrar'} Produto de Serviço Automotivo {formData.id > 0 ? '-' : ''} {formData.code}</div>

            <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
                <div>
                    <label>Nome:</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        style={{width: '100%'}}
                        placeholder="Digite o nome do produto"
                    />
                </div>

                <div>
                    <label>Tipo:</label>
                    <select
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                        style={{width: '100%'}}
                    >
                        <option value="">Selecionar tipo</option>
                        <option value="PRODUCT">Produto</option>
                        <option value="SERVICE">Serviço</option>
                    </select>
                </div>

                <div>
                    <label>Valor:</label>
                    <input
                        type="number"
                        name="value"
                        value={formData.value}
                        onChange={handleChange}
                        step="0.01"
                        min="0"
                        style={{width: '100%'}}
                        placeholder="0.00"
                    />
                </div>
            </div>

            <ActionButtonsManagerView>
                <ConfirmButton onClick={onConfirm}/>
            </ActionButtonsManagerView>
        </div>
    );
};

export default ProductAutomotiveServiceManager; 